import { AutomationsPage } from '@pages';
import type { RouteObject } from 'react-router';
import OrgFeatureFlaggedRoute from 'src/rbac/OrgFeatureFlaggedRoute';

export const automationsRoute: RouteObject = {
  path: '',
  children: [
    {
      index: true,
      element: (
        <OrgFeatureFlaggedRoute featureFlag={'integrations'}>
          <AutomationsPage />
        </OrgFeatureFlaggedRoute>
      ),
    },
  ],
};
